<template>
  <div class="no-task">
      <div>
          <img 
            class="no-task_img"
            src="../../../assets/images/oldCustomer/no_task.png" 
            alt=""
          >
      </div>
      <div class="no-task_text">{{$t('sailing.act-api-intl.活动已经结束')}}</div>
      <div class="no-task_button">
         <rich-button :outline="true" @click="goUrl" >{{gettext('返回首页')}}</rich-button>
         
      </div>
  </div>
</template>

<script>
import {homepageTaskCenterNoneSw} from '../trackEvent'
import {
  getScheme
} from '@/common/js/utils'
export default {
  name: 'NoTask',
  mounted(){
    homepageTaskCenterNoneSw()
  },
  methods: {
    goUrl () {
      location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
    }
  }
}
</script>

<style lang="stylus" scoped>
.no-task
    padding-top 350px
    div
        display flex
        justify-content center
        margin-bottom 56px
        .no-task_img 
            width 312px
            height 312px
            margin 0 auto
.no-task_text
    height 44px
    font-family 'Aspira Medium'
    font-size 44px
    color #000000
    letter-spacing 0
    font-weight 500
    text-align center
.no-task_button
    height 60px
    margin 0 auto
    font-family 'Aspira Regular'
    font-size 28px
    color #FF7A45
    font-weight 400
    padding 0 24px
    button
        width auto
</style>